import { memo } from 'react';
import { EmailIcon, ExternalLinkIcon, LocationIcon, PhoneIcon } from 'shared/icon/icon';
import WebsiteIcon from 'shared/icon/WebsiteIcon';

type FooterLink = {
	label: string;
	href: string;
};

const PHONE_NUMBERS = ['+919574701845', '+918780518737'];
const PHONE_NUMBERS_SAINIK_SCHOOL = ['+919825348948'];
const EMAILS = ['pgsmodasa@gmail.com'];
const SAINIK_SCHOOL_WEBSITE = 'https://pgssmodasa.com/';
// const EMAILS_SAINIK_SCHOOL = ['pgssmodasa@gmail.com'];
const CURRENT_YEAR = new Date().getFullYear();

const ABOUT_LINKS: FooterLink[] = [
	{ label: 'About Prarthana School', href: '/aboutschool' },
	{ label: 'Mission & vision', href: '/mission&vision' },
	{ label: "Chairman's Message", href: '/chairman' },
	{ label: 'Rules & Regulation', href: '/rules&regulation' },
	{ label: 'School System', href: '/schoolsystem' },
	{ label: 'CBSE Mandatory Disclosure', href: '/cbsemandatorydiscolsure' }
];

const ACADEMICS_LINKS: FooterLink[] = [
	{ label: 'List Of Holidays', href: '/academics/16' },
	{ label: 'Academic Calendar', href: '/academics/10' },
	{ label: 'CCA & Competitions', href: '/academics/17' },
	{ label: 'National Education Policy', href: '/academics/18' },
	{ label: 'Exam Time Table', href: '/academics/19' },
	{ label: 'Fees', href: '/fees/9' }
];

const ACTIVITY_LINKS: FooterLink[] = [
	{ label: 'Co-Curricular Activities', href: '/cocurricularactivity' },
	{ label: 'Sports & Game', href: '/sports&game' },
	{ label: 'Art Room', href: '/art' },
	{ label: 'Music Room', href: '/music' },
	{ label: 'Dance Room', href: '/dance' },
	{ label: 'Housing & Dining', href: '/housing&dining' }
];

const Footer = () => {
	const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
		event.preventDefault();
		window.open(
			'https://www.sitelock.com/verify.php?site=prarthanaglobalschool.com',
			'SiteLock',
			'width=600,height=600,left=160,top=170,noopener,noreferrer'
		);
	};

	return (
		<footer className='footer-wrapper flex flex--column width--full mt--150'>
			<div className='flex justify__content--evenly footer--container'>
				<div className='flex flex--column footer--box'>
					<p className='font-size--17 font-weight--700'>About Us</p>
					{ABOUT_LINKS.map(({ label, href }) => (
						<a key={href} href={href} className='footer-link-text text-decoration--none text--grey font-weight--500 mb--10'>
							{label}
						</a>
					))}
				</div>

				<div className='flex flex--column footer--box'>
					<p className='font-size--17 font-weight--700'>Academics</p>
					{ACADEMICS_LINKS.map(({ label, href }) => (
						<a key={href} href={href} className='footer-link-text text-decoration--none text--grey font-weight--500 mb--10'>
							{label}
						</a>
					))}
				</div>

				<div className='flex flex--column footer--box'>
					<p className='font-size--17 font-weight--700'>Activity</p>
					{ACTIVITY_LINKS.map(({ label, href }) => (
						<a key={href} href={href} className='footer-link-text text-decoration--none text--grey font-weight--500 mb--10'>
							{label}
						</a>
					))}
				</div>

				<div className='flex flex--column footer--box'>
					<p className='font-size--17 font-weight--700'>Get In Touch</p>

					<div className='flex align__items--center mb--20'>
						<PhoneIcon className='width--20-px mr--20' />
						<span className='footer-link-text text--grey font-weight--500'>
							{PHONE_NUMBERS.map((phone, index) => (
								<span key={phone}>
									<a href={`tel:${phone}`} className='footer-link-text text--grey'>
										{phone}
									</a>
									{index < PHONE_NUMBERS.length - 1 && ' (For CBSE)'}
									{index < PHONE_NUMBERS.length - 1 && ', '}
								</span>
							))}
						</span>
					</div>

					<div className='flex align__items--center mb--20'>
						<PhoneIcon className='width--20-px mr--20' />
						<span className='footer-link-text text--grey font-weight--500'>
							{PHONE_NUMBERS_SAINIK_SCHOOL.map((phone) => (
								<span key={phone}>
									<a href={`tel:${phone}`} className='footer-link-text text--grey'>
										{phone} (Only for Sainik School)
									</a>
								</span>
							))}
						</span>
					</div>

					<div className='flex align__items--center mb--20'>
						<WebsiteIcon className='width--20-px mr--20' />

						<span className='footer-link-text text--grey font-weight--500'>
							<a
								href={SAINIK_SCHOOL_WEBSITE}
								target='_blank'
								rel='noopener noreferrer'
								className='footer-link-text text--grey text-decoration--none'
							>
								{SAINIK_SCHOOL_WEBSITE} (For Sainik School)
							</a>
							<span className='ml--5'>
								<ExternalLinkIcon />
							</span>
						</span>
					</div>

					<div className='flex align__items--center mb--20'>
						<LocationIcon className='location-icon width--30-px mr--20' />
						<span className='footer-link-text text--grey font-weight--500'>
							Prarthana Global School, At & Po- Madapurkampa, Modasa, Gujarat 383315
						</span>
					</div>

					<div className='flex align__items--center'>
						<EmailIcon className='width--20-px mr--20' />
						<span className='footer-link-text text--grey font-weight--500'>
							{EMAILS.map((email, index) => (
								<span key={email}>
									<a href={`mailto:${email}`} className='text-decoration--none footer-link-text text--grey'>
										{email}
									</a>
									{index < EMAILS.length - 1 && ', '}
								</span>
							))}
						</span>
					</div>

					{/* <div className='flex align__items--center'>
						<EmailIcon className='width--20-px mr--20' />
						<span className='footer-link-text text--grey font-weight--500'>
							{EMAILS_SAINIK_SCHOOL.map((email, index) => (
								<span key={email}>
									<a href={`mailto:${email}`} className='text-decoration--none footer-link-text text--grey'>
										{email} (Only For Sainik School)
									</a>
									{index < EMAILS.length - 1 && ', '}
								</span>
							))}
						</span>
					</div> */}
				</div>
			</div>

			<div className='footer-bottom-text-wrapper flex justify__content--evenly p--25 copy-right--container mt--60 align__items--center'>
				<p className='bottom-text text--grey font-weight--500'>Copyright © {CURRENT_YEAR} Prarthana Global School. All Rights Reserved.</p>

				<a href='https://www.sitelock.com/verify.php?site=prarthanaglobalschool.com' onClick={handleClick}>
					<img className='img-fluid' alt='SiteLock' title='SiteLock' src='https://shield.sitelock.com/shield/prarthanaglobalschool.com' />
				</a>

				<p className='bottom-text text--grey font-weight--500'>
					Developed By:{' '}
					<a
						href='mailto:yashupadhyay312@gmail.com'
						rel='noopener noreferrer'
						className='bottom-text text--grey font-weight--500'
						title='Email-Id'
					>
						Yash Upadhyay
					</a>
				</p>
			</div>
		</footer>
	);
};

export default memo(Footer);
